<!-- CSVパターン一覧-->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
	<div class="contents" id="csvPtnLst">
		<!-- ▽ 各種操作ボタン部分 -->
		<section id="mainContent">
		  <h2>CSVパターン一覧</h2>
			<ul class="contntMenu">
				<li class="onBack" v-on:click="onBack">TOP</li>
			</ul>
			<!-- ▽ パターン一覧 -->
			<section>
			  <table class="listTbl">
			  	<caption>
			  		<div class="btnLst">
			  			<button class="newBtn" v-on:click="onRegister">新規作成</button>
			  			<button class="copyBtn" v-on:click="onCopy">コピー</button>
			  		</div>
			  	</caption>
			  	<thead>
			  		<tr>
			  			<th>初期表示</th>
			  			<td>パターン名</td>
			  			<td></td>
			  		</tr>
			  	</thead>
			  	<tbody>
			  		<tr v-for="(item,index) in csv1List" v-bind:key="item.ptcd">
			  			<!-- 初期表示選択 -->
			  			<th class="selected" v-if="item.dffg=='1'"><span>選択中</span></th>
			  			<th v-else></th>
  
			  			<th>
			  				<label class="radio" v-bind:for="getBindId('ptcd',index)"><input type="radio" v-bind:id="getBindId('ptcd',index)" v-bind:value="item.ptcd" v-model="choicePtcd"><span>{{item.ptnm}}</span></label>
			  			</th>
			  			<td class="btnLst">
			  				<button class="detailBtn" v-on:click="onDetail(item.ptcd)">詳細</button>
			  				<button class="dltBtn" v-on:click="onDelete(item.ptcd)">削除</button>
			  			</td>
			  		</tr>
			  	</tbody>
			  </table>
			</section>
			<!-- △ パターン一覧 END-->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmCopy.isShow" v-on:close="onConfirmCopyModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmCopy.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="copyExecute">OK</button></li>
					<li><button v-on:click="onConfirmCopyModalClose">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmDelete.isShow" v-on:close="onConfirmDeleteModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmDelete.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="deleteExecute">OK</button></li>
					<li><button v-on:click="onConfirmDeleteModalClose">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>
<script>
	import { CSVPatternListApi } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		// モジュール名
		name: 'CSVPatternList',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow
		},
		// データ
		data() {
			return {
				// CSV出力用項目テンプレートマスタ（メイン）
				// ptcd: パターンコード
				// ptnm: パターン名称
				// dffg: 初期区分
				csv1List: [],

				// 削除
				choicePtcd: '',

				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					confirmCopy:{
						messages: ['コピーしますか？'],
						isShow: false
					},
					confirmDelete: {
						messages: ['削除しますか？'],
						isShow: false
					},
				}
			}
		},
		created: function () {
			UtilityConsoleLog.consoleLog('CSVPatternList::created Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog('CSVPatternList::created End')
		},
		methods: {
			// 初期表示
			firstDisplay: function() {
				UtilityConsoleLog.consoleLog('CSVPatternList::firstDisplay Start')

				// 非同期通信
				CSVPatternListApi.FirstDisplay({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {
						// CSV出力用項目テンプレートマスタ（メイン）
						this.csv1List = responce.data.csv1List

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('CSVPatternList::firstDisplay End')
				})
			},
			// 新規作成
			onRegister: function() {
				UtilityConsoleLog.consoleLog('CSVPatternList::onRegister Start')

				// 選択したレコードのptcdをstoreに登録
				this.$store.commit(
					types.ADMIN_USERCHOICE_CSVPATTERN_LISTTODETAIL,
					 { 
						 ptcd: '000'
					 }
				)

				// 詳細画面に遷移
				this.$router.push("/CSVPatternDetail") 

				UtilityConsoleLog.consoleLog('CSVPatternList::onRegister End')
			},
			// コピー実行
			copyExecute: function() {
				UtilityConsoleLog.consoleLog('CSVPatternList::copyExecute Start')

				// 非同期通信
				CSVPatternListApi.Copy({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					ptcd: this.choicePtcd
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {
						// CSV出力用項目テンプレートマスタ（メイン）
						this.csv1List = responce.data.csv1List

						// コピー確認モーダルを閉じる
						this.onConfirmCopyModalClose()

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// コピー確認モーダルを閉じる
						this.onConfirmCopyModalClose()
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('CSVPatternList::copyExecute End')
				})
			},
			// コピー
			onCopy: function() {

				if('' == this.choicePtcd) {

					var messages = [
						'コピーするパターンを選んでください。'
					]

					// バリエーションダイアログの表示
					this.onValidationErrorModalOpen(messages)

					return
				}

				// コピー確認モーダルを開く
				this.onConfirmCopyModalOpen()

			},
			// 戻る
			onBack: function() {
				UtilityConsoleLog.consoleLog('CSVPatternList::onBack Start')

				// 詳細画面に遷移
				this.$router.push("/AdminReserveStatusCheck") 

				UtilityConsoleLog.consoleLog('CSVPatternList::onBack End')
			},
			// 詳細
			onDetail: function(in_ptcd) {
				UtilityConsoleLog.consoleLog('CSVPatternList::onDetail Start')

				// 選択したレコードのptcdをstoreに登録
				this.$store.commit(
					types.ADMIN_USERCHOICE_CSVPATTERN_LISTTODETAIL,
					 {
						 ptcd: in_ptcd
					 }
				)

				// 詳細画面に遷移
				this.$router.push("/CSVPatternDetail") 

				UtilityConsoleLog.consoleLog('CSVPatternList::onDetail End')
			},
			// 削除実行
			deleteExecute: function() {
				UtilityConsoleLog.consoleLog('CSVPatternList::deleteExecute Start')

				// 非同期通信
				CSVPatternListApi.Delete({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					ptcd: this.choicePtcd
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// CSV出力用項目テンプレートマスタ（メイン）
						this.csv1List = responce.data.csv1List

						// 削除確認モーダルを閉じる
						this.onConfirmDeleteModalClose()

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('CSVPatternList::deleteExecute End')
				})
			},
			// 削除ボタン押下時
			onDelete: function(in_ptcd) {

				UtilityConsoleLog.consoleLog('CSVPatternList::onDelete Start')

				// 選択したレコードのパターンコードを取得
				this.choicePtcd = in_ptcd

				// 削除確認モーダルを開く
				this.onConfirmDeleteModalOpen()

				UtilityConsoleLog.consoleLog('CSVPatternList::onDelete End')
			},
			// ラジオ用 for、idに名前割り当て
			getBindId: function(in_for,in_index) {
				return in_for + String(in_index)
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('CSVPatternList::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('CSVPatternList::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('CSVPatternList::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('CSVPatternList::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('CSVPatternList::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('CSVPatternList::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('CSVPatternList::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('CSVPatternList::onSystemErrorModalClose End')
			},
			// コピー確認モーダルを開く
			onConfirmCopyModalOpen: function () {
				UtilityConsoleLog.consoleLog('CSVPatternList::onConfirmCopyModalOpen Start')

				this.modalOpen('confirmCopy')

				UtilityConsoleLog.consoleLog('CSVPatternList::onConfirmCopyModalOpen End')
			},
			// コピー確認モーダルを閉じる
			onConfirmCopyModalClose: function () {
				UtilityConsoleLog.consoleLog('CSVPatternList::onConfirmCopyModalClose Start')

				this.choicePtcd = ''

				this.modalClose('confirmCopy')

				UtilityConsoleLog.consoleLog('CSVPatternList::onConfirmCopyModalClose End')
			},
			// 削除確認モーダルを開く
			onConfirmDeleteModalOpen: function () {
				UtilityConsoleLog.consoleLog('CSVPatternList::onConfirmDeleteModalOpen Start')

				this.modalOpen('confirmDelete')

				UtilityConsoleLog.consoleLog('CSVPatternList::onConfirmDeleteModalOpen End')
			},
			// 削除確認モーダルを閉じる
			onConfirmDeleteModalClose: function () {
				UtilityConsoleLog.consoleLog('CSVPatternList::onConfirmDeleteModalClose Start')

				this.choicePtcd = ''

				this.modalClose('confirmDelete')

				UtilityConsoleLog.consoleLog('CSVPatternList::onConfirmDeleteModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('CSVPatternList::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('CSVPatternList::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('CSVPatternList::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('CSVPatternList::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Admin/Master/WCSV/CSVPatternList.vue